import { AltRoute } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  areaWaypointReactKey,
  DirectionEnum,
  IAreaWaypoint,
  IGeoJSON,
  TAreaWaypointDirection,
} from "@ryde/shared";

import { AreaWaypointsMap } from "./area-waypoints.map";
import {
  AreaWaypointBadgeStyled,
  AreaWaypointsEditButtonStyled,
} from "./area-waypoints.styled";

interface IAreaWaypointsTableProps {
  direction: TAreaWaypointDirection;
  waypoints: IAreaWaypoint[];
  polygon?: IGeoJSON | null;
  disabled?: boolean;
  onEdit: (direction: TAreaWaypointDirection) => void;
}

export const AreaWaypointsTable: FC<IAreaWaypointsTableProps> = ({
  direction,
  waypoints,
  polygon,
  disabled,
  onEdit,
}) => {
  const { t } = useTranslation();
  const directionLabel =
    direction === DirectionEnum.DropOff
      ? t("area.formLabel.areaWaypointsDirectionB")
      : t("area.formLabel.areaWaypointsDirectionA");

  return (
    <div className="area-waypoints-table-card">
      <p className="area-waypoints-table-title">{directionLabel}</p>
      {/* One map per direction so A and B can share coordinates without colliding markers. */}
      <AreaWaypointsMap
        className="area-waypoints-map"
        direction={direction}
        waypoints={waypoints}
        polygon={polygon}
      />
      {waypoints.length ? (
        <table className="area-waypoints-table">
          <thead>
            <tr>
              <th>#</th>
              <th>{t("area.formLabel.areaWaypointName")}</th>
            </tr>
          </thead>
          <tbody>
            {waypoints.map((waypoint, index) => (
              <tr key={areaWaypointReactKey(direction, waypoint.id)}>
                <td>{index + 1}</td>
                <td>
                  <div className="area-waypoints-name">
                    <AreaWaypointBadgeStyled>w</AreaWaypointBadgeStyled>
                    <span className="area-waypoints-name-text">
                      {waypoint.name || waypoint.fullAddress}
                    </span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="area-waypoints-empty">
          {t("area.formLabel.areaWaypointsEmpty")}
        </div>
      )}
      <div className="area-waypoints-edit">
        <AreaWaypointsEditButtonStyled
          disabled={disabled}
          onClick={() => onEdit(direction)}
        >
          <AltRoute />
          <span>{t("area.formLabel.areaWaypointsAddOrEdit")}</span>
        </AreaWaypointsEditButtonStyled>
      </div>
    </div>
  );
};
